import apiClient from "./apiClient";

export const slotsByMerchantId = async (merchantId: string, status?: string, ProjectionExpression?: string[]) => {
    if (!merchantId) throw new Error("merchantId is required");

    const params: any = {
        filterParams: {
            IndexName: "merchantId-slotApprovalStatus-index",
            KeyConditionExpression: "merchantId = :merchantId and slotApprovalStatus = :slotApprovalStatus",
            ExpressionAttributeValues: {
                ":merchantId": merchantId,
                ":slotApprovalStatus": status ?? "APPROVED",
            },
        },
    };

    if (ProjectionExpression) {
        params.filterParams.ProjectionExpression = ProjectionExpression.join(",");
    }

    try {
        const response = await apiClient.post(`/TripSlots/bulk-ops/query`, params);
        return response.data;
    } catch (error) {
        console.error("Error fetching slots:", error);
        throw error;
    }
};

export const bookingBySlotId = async (slotId:string,status?:string, ProjectionExpression?: string[]) => {
    if(!slotId) throw new Error("slotId is required");
    const params: any = {
        filterParams: {
            IndexName: "slotId-bookingStatus-index",
            KeyConditionExpression: "slotId = :slotId and bookingStatus = :status1",
            ExpressionAttributeValues: {
                ":slotId": slotId,
                ":status1": status ?? "CONFIRMED",
            },
        },
    };

    if (ProjectionExpression) {
        params.filterParams.ProjectionExpression = ProjectionExpression.join(",");
    }

    try {
        const response = await apiClient.post(`/Bookings/bulk-ops/query`, params);
        return response.data;
    } catch (error) {
        console.error("Error fetching slots:", error);
        throw error;
    }
}


export const bookingByMerchantId = async (merchantId:string,bookingStatus?:string,ProjectionExpression?: string[]) => {
    if(!merchantId) throw new Error("merchantId is required");
    const params: any = {
        filterParams: {
            IndexName: "merchantId-bookingStatus-index",
            KeyConditionExpression: "merchantId = :merchantId and bookingStatus= :status1",
            ExpressionAttributeValues: {
                ":merchantId": merchantId,
                ":status1": bookingStatus ?? "CONFIRMED",
            },
        },
    };
    if (ProjectionExpression) {
        params.filterParams.ProjectionExpression = ProjectionExpression.join(",");
    }
    try {
        const response = await apiClient.post(`/Bookings/bulk-ops/query`, params);
        return response.data;
    } catch (error) {
        console.error("Error fetching slots:", error);
        throw error;
    }

}

export const bookingUpdateById = async (id:string,data:any) => {
    try {
        const response = await apiClient.put(`/Bookings/id/${id}`, data);
        return response.data;
    } catch (error) {
        console.error("Error updating booking:", error);
        throw error;
    }
};

export const updateBookingNoted = async (id: string, isNoted: boolean) => {
    try {
        const response = await apiClient.put(`/Bookings/id/${id}`, { isNoted });
        return response.data;
    } catch (error) {
        console.error("Error updating booking noted status:", error);
        throw error;
    }
};


export const bookingByBookingStatus = async (status?:string,ProjectionExpression?: string[]) => {

    const params: any = {
        filterParams: {
            IndexName: "bookingStatus-index",
            KeyConditionExpression: "bookingStatus= :status1",
            ExpressionAttributeValues: {
                ":status1": status?? "CONFIRMED",
            },
        },
    };

    if (ProjectionExpression) {
        params.filterParams.ProjectionExpression = ProjectionExpression.join(",");
    }

    try {
        const response = await apiClient.post(`/Bookings/bulk-ops/query`, params);
        return response.data;
    } catch (error) {
        console.error("Error fetching slots:", error);
        throw error;
    }
}

export const bookingBySlotStatus = async (status: string, ProjectionExpression?: string[]) => {
    if (!status) throw new Error("status is required");

    const params: any = {
        filterParams: {
            IndexName: "slotApprovalStatus-index",
            KeyConditionExpression: "slotApprovalStatus = :slotApprovalStatus",
            ExpressionAttributeValues: {
                ":slotApprovalStatus": status,
            },
        },
    };

    if (ProjectionExpression) {
        params.filterParams.ProjectionExpression = ProjectionExpression.join(",");
    }

    try {
        const response = await apiClient.post(`/TripSlots/bulk-ops/query`, params);
        return response.data;
    } catch (error) {
        console.error("Error fetching slots:", error);
        throw error;
    }
};

export const bookingById = async (bookingId: string) => {
  if (!bookingId) throw new Error("bookingId is required");
  try {
    const response = await apiClient.get(`/Bookings/id/` + bookingId);
    return response.data;
  } catch (error) {
    console.error("Error fetching booking by ID:", error);
    throw error;
  }
};